<template>
  <div class="lastArticlesContainer tour-details">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>
      <v-toolbar-title class="pageTitle">
        Tour
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div style="padding-top: 20px; padding-bottom: 80px;" class="contentWrapper checkoutContent">
      <div v-for="(order, index) in orders"
           :key="index"
           style="margin-bottom: 40px;"
      >
        <div class="tour-main-card">
          <span>{{order.OrderNo}}</span>
          <span>{{order.CustNo}}</span>
          <span>{{order.CustName}}</span>
          <span>{{order.CustAddress}}</span>
          <span>{{order.CustPostCode}} {{order.CustCity}}</span>
          <span>{{order.CustPhone}}</span>
          <v-divider/>
          <span>Rollis: {{order.NoOfRollis}}</span>
          <span>Rollis-TK: {{order.NoOfRollisDF}}</span>
        </div>
        <v-btn class="tour-nav-forward-btn"  @click="openOptionsDialog(order)">
          Details ansehen
        </v-btn>
      </div>
      <div v-if="!ordersRequestLoading && orders.length === 0">
        Keine Touren-Details vorhanden
      </div>

      <v-dialog v-model="dialog" persistent eager content-class="tour-dialog">
        <v-btn
          class="closeBtn leftRounded tour-dialog-close"
          @click="dialog = false"
        >
          <v-icon color="white" left>mdi-close</v-icon>
        </v-btn>
        <div style="height: 100%; background-color: white;" class="tour-dialog-content">
          <div class="dialog-header" v-if="activeItem">
            {{activeItem.CustName}}
          </div>
          <div class="dialog-main" v-if="activeItem">
            <span>{{activeItem.OrderNo}}</span>
            <span>{{activeItem.CustNo}}</span>
            <span>{{activeItem.CustName}}</span>
            <span>{{activeItem.CustAddress}}</span>
            <span>{{activeItem.CustPostCode}} {{activeItem.CustCity}}</span>
            <span>{{activeItem.CustPhone}}</span>
            <span v-if="activeItem.DeliveryInfo" v-html="parsedDeliveryInfo"></span>
            <v-divider/>
            <span>Rollis: {{activeItem.NoOfRollis}}</span>
            <span>Rollis-TK: {{activeItem.NoOfRollisDF}}</span>
          </div>
          <div class="dialog-options" v-if="activeItem">
            <v-btn @click="call" class="action-btn" :disabled="!phone">
              <v-icon>
                mdi-phone-outline
              </v-icon>
              Anrufen
            </v-btn>
            <v-btn @click="navigate" class="action-btn" :disabled="!address">
              <v-icon>
                mdi-navigation-outline
              </v-icon>
              Navigieren
            </v-btn>
            <v-btn @click="startDeposit" class="action-btn">
              <v-icon>
                mdi-recycle-variant
              </v-icon>
              Pfandrückgabe
            </v-btn>
            <v-btn @click="deposit" class="action-btn" :disabled="activeItem.finished === 1">
              <v-icon>
                mdi-package-variant-closed
              </v-icon>
              Abladen
            </v-btn>
            <v-btn @click="send" class="action-btn" :disabled="!activeItemSignature || activeItem.finished === 1">
              <v-icon>
                mdi-send-variant-outline
              </v-icon>
              Senden
            </v-btn>
          </div>

        </div>
      </v-dialog>
      <v-dialog persistent eager content-class="tour-dialog"
                v-bind:value="signaturePadState"
      >
        <v-btn
          class="closeBtn leftRounded tour-dialog-close"
          @click="signaturePadState = false"
        >
          <v-icon color="white" left>mdi-chevron-left</v-icon>
        </v-btn>
        <div class="tour-signature-wrapper">
          <div v-if="activeItem">
            <span>Rollis: {{activeItem.NoOfRollis}}</span>
            <span>Rollis-TK: {{activeItem.NoOfRollisDF}}</span>
            <span>Es gelten die AGBs</span>
            <span>Temperatur bei kühlpflichtigen Artikeln wurde geprüft und ist im Rahmen der gesetzlichen Vorgaben.</span>
            <VueSignaturePad
              ref="signaturePad"
              :options="{options, onBegin}"
              class="sign-pad"
              v-if="!activeItemSignature"
            />
            <div width="100%"
                 height="100%"
                 v-html="activeItemSignature"
                 class="sign-display" v-if="activeItemSignature">

            </div>

          </div>
          <v-btn class="signature-delete-btn" dense icon @click="deleteSignature">
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import { mapMutations } from "vuex";
import { findPhoneNumbersInText } from 'libphonenumber-js'
export default {
  name: "TourDetails",
  data() {
    return {
      orders: [],
      ordersRequestLoading: true,
      dialog: false,
      activeItem: null,
      signaturePadState: false,
      requestPending: false,
      requestState: null,
      loadingOverlay: false,
      options: {
        penColor: "#c0f",
        backgroundColor: '#ffffff'
      },
      activeItemSignature: null
    }
  },
  watch: {
    signaturePadState: {
      handler(state) {
        if(!state) {
          if(this.$refs.signaturePad && !this.$refs.signaturePad.saveSignature().isEmpty) {
            let data = this.$refs.signaturePad.saveSignature('image/svg+xml').data
            let jpeg = this.$refs.signaturePad.saveSignature('image/png').data
            this.$refs.signaturePad.clearSignature()
            let currentSignatures = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
            if(!currentSignatures) {
              currentSignatures = {}
            }
            currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`] = {jpeg: jpeg, svg: window.atob(data.split(",")[1])}
            localStorage.setItem('currentSignaturesTourData', JSON.stringify(currentSignatures))
            this.activeItemSignature = currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`].svg
          }
        }
      }
    }
  },
  async mounted() {
    this.ordersRequestLoading = true
    const result = await axios.get('/api/tour-data/show/' + router.currentRoute.params.id)
    this.orders.push(...result.data.data)
    this.ordersRequestLoading = false
  },
  closeOptionsDialog() {
    this.activeItem = null
    this.activeItemSignature = null
    this.dialog = false
  },
  methods: {
    ...mapMutations({
      setRequestStateTourData: 'setRequestStateTourData',
      setRequestPendingTourData: 'setRequestPendingTourData',
      setLoadingOverlayTourData: 'setLoadingOverlayTourData'
    }),
    deleteSignature() {
      let currentSignatures = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
      if(currentSignatures && currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]) {
        delete currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]
        localStorage.setItem('currentSignaturesTourData', JSON.stringify(currentSignatures))
      }
      if(this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature()
      }
      this.activeItemSignature = null
    },
    goBack() {
      router.go(-1)
    },
    onBegin() {
      this.$nextTick(() => {
        this.$refs.signaturePad.resizeCanvas()
      })
    },
    call() {
      const url = `tel://${this.phone}`
      window.location.href = url
    },
    navigate() {
      window.open(this.address)
    },
    deposit() {
      this.signaturePadState = true
    },
    async send() {
      let currentSignatures = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
      let currentSignature = currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]
      const params = {
        tour_id: router.currentRoute.params.id,
        orderNo: this.activeItem.OrderNo,
        signature_jpeg: currentSignature.jpeg,
        customerNo: this.activeItem.CustNo
      }
      try {
        this.setRequestPendingTourData(true)
        this.setLoadingOverlayTourData(true)
        const result = await axios.post('/api/tour-data-orders/store', params, {timeout: 40000}).catch(() => {

        })
        if(result?.data?.status === 1) {
          // immediate set
          this.activeItem.finished = 1
          this.setRequestStateTourData('success')
          this.setRequestPendingTourData(false)
          setTimeout(() => {
            this.setLoadingOverlayTourData(false)
            this.setRequestStateTourData(null)
          }, 3000)

          // reload anyways
          const result2 = await axios.get('/api/tour-data/show/' + router.currentRoute.params.id)
          this.orders.splice(0, this.orders.length, ...result2.data.data)
          // find index of order
          const itemIndex = this.orders.findIndex(el => el.OrderNo === this.activeItem.orderNo && el.CustNo === this.activeItem.orderNo)
          if(itemIndex > -1) {
            this.activeItem = this.orders[itemIndex]
          }
          // remove signature
          let currentSignatures = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
          if(currentSignatures && currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]) {
            delete currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]
            localStorage.setItem('currentSignaturesTourData', JSON.stringify(currentSignatures))
          }
        } else {
          this.setRequestStateTourData('timeout')
          this.setRequestPendingTourData(false)
          setTimeout(() => {
            this.setLoadingOverlayTourData(false)
            this.setRequestStateTourData(null)
          }, 3000)
        }
      } catch (e) {
        console.warn(e)
      }
    },
    startDeposit() {
      // get market from list
      router.push({name:'bottleDepositList', params: {externalSetMarket: this.activeItem.CustNo, comesFromTours: true}})
    },
    openOptionsDialog(order) {
      this.activeItem = order
      let currentSignatures = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
      if(!currentSignatures) {
        this.activeItemSignature = null
      } else {
        this.activeItemSignature = currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]?.svg ? currentSignatures[`${this.activeItem.OrderNo}_${this.activeItem.CustNo}_${router.currentRoute.params.id}`]?.svg : null
      }
      this.dialog = true
    }
  },
  computed: {
    parsedDeliveryInfo() {
      let text = this.activeItem?.DeliveryInfo ? this.activeItem?.DeliveryInfo : null
      if(!text) {
        return null
      }
      text = `Hinweis: ${text}`
      const matches = findPhoneNumbersInText(text, 'DE')
      if (matches.length === 0) return text;
      let result = text;
      for (let i = matches.length - 1; i >= 0; i--) {
        const { startsAt, endsAt, number } = matches[i];
        const telLink = `<a href="tel:${number.number}">${text.slice(startsAt, endsAt)}</a>`;
        result = result.slice(0, startsAt) + telLink + result.slice(endsAt);
      }

      return result;
    },
    phone() {
      if(!this.activeItem?.CustPhone) {
        return null
      }
      let number = this.activeItem.CustPhone.replace(/\D/g, '')
      if(number.startsWith('0')) {
        number = '+49'+number.substring(1)
      }
      return number
    },
    address() {
      if(!this.activeItem?.CustAddress || !this.activeItem?.CustCity || !this.activeItem?.CustPostCode) {
        return null
      }
      let address = `${this.activeItem.CustAddress}+${this.activeItem.CustPostCode}+${this.activeItem?.CustCity}`
      address = address.replace(/ /g, '+')
      return `https://www.google.com/maps/place/${address}`
    }
  }
}
</script>

<style src="./tours.css">

</style>
